import { TSFontSpecs } from "react-native-text-size";

export const getTextLineCount = (text: string, maxWidth: number, style: TSFontSpecs) => {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d") as CanvasRenderingContext2D;
    ctx.font = `${style.fontSize}px ${style.fontFamily} ${style.fontWeight}`;

    const words = text.split(" ");
    let lineCount = 1;
    let currentLineWidth = 0;

    words.forEach((word) => {
        const wordWidth = ctx.measureText(word + " ").width;
        if (currentLineWidth + wordWidth > maxWidth) {
            lineCount++;
            currentLineWidth = wordWidth;
        } else {
            currentLineWidth += wordWidth;
        }
    });

    return lineCount;
};
